module.exports = __webpack_public_path__ + "images/double_caret_vertical.svg";